import { useAuth, useOrganization, useUser } from "@clerk/clerk-react";
import { ErrorBoundary } from "@sentry/react";
import { useQueryClient } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import Providers from "@/shared/providers";

import { router } from "./router";
import { useInitializeAuthorizationHeaderInterceptor } from "./shared/api/client";
import { useAppAbility } from "./shared/providers/casl-provider/use-app-ability";
import { useSetSentryUser } from "./shared/utils/sentry/setSentryUser";

function InnerApp() {
  const queryClient = useQueryClient();
  const ability = useAppAbility();

  const user = useUser();
  const auth = useAuth();
  const organization = useOrganization();

  useInitializeAuthorizationHeaderInterceptor(auth.getToken);
  useSetSentryUser();

  if (auth.isLoaded && organization.isLoaded) {
    return (
      <RouterProvider
        router={router}
        context={{
          auth: auth,
          user: user,
          organization,
          queryClient,
          ability,
        }}
      />
    );
  }

  return null;
}

export default function App() {
  return (
    <ErrorBoundary>
      <Providers>
        <InnerApp />
      </Providers>
    </ErrorBoundary>
  );
}
